var hardBreak = {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [{ tag: 'br' }],
    toDOM: function () {
        return ['br'];
    },
};

export { hardBreak };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/hard-break.js